// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: AddUserPage.js
// Description: This file is responsible for Add users
//
// ************************************************************************************************************************************************************
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { makeStyles } from "@material-ui/core";
import { Select } from "@material-ui/core";
import { MenuItem } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  addUser,
  editUser,
  getUserDetailsById,
  resetUser,
} from "../_redux/userCrud";
import { getAllFacilityNames } from "../../Facilities/_redux/facilityCrud";
import CountryCode from "../../data/CountryCode.json";
import {
  FormControl,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogContentText,
  DialogActions,
  InputAdornment,
} from "@material-ui/core";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import CloseIcon from "@material-ui/icons/CloseOutlined";
import { Slide } from "@material-ui/core";
import AsyncSelect from "react-select/async";
import debounce from "lodash/debounce";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#158380",
    },
  },
  alertMsg: {
    color: "red",
  },
  MuiBackdrop: {
    backgroundColor: "rgba(0,0,0,0.6)",
  },
}));

let initialValues = {
  fname: "",
  lname: "",
  email: "",
  phone: "",
  location: "",
  cDate: "",
};

export default function AddUserPage(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [responseStatus, setResponse] = useState(false);
  const [errorMsg, setMessage] = useState("");
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [countryCode, setCountryCode] = useState("+1");
  const [isLocationError, setIsLocationError] = useState(false);
  const [uiLoading, setUiLoading] = useState(false);
  const [locationError, setLocationError] = useState(
    "Please Select atleast one facility"
  );
  const [, setFacilities] = useState(null);
  const [users, setUsers] = useState(null);
  const [resetMsg, setResetMsg] = useState(null);
  const [resetLoading, setResetLoading] = useState(false);
  const selectfacilityRef = useRef(null);
  const FacilitySchema = Yup.object().shape({
    fname: Yup.string()
      .trim()
      .required("First Name is required"),
    lname: Yup.string()
      .trim()
      .required("Last Name is required"),
    email: Yup.string()
      .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Email is required"),
    phone: Yup.number()
      .moreThan(999999999, "10 digits required")
      .typeError("Numbers are allowed")
      .required("Phone Number is required"),
    location: Yup.string(),
  });

  const enableLoading = () => {
    setLoading(true);
  };
  const disableLoading = () => {
    setLoading(false);
  };
  const disableMessage = () => {
    setResponse(false);
  };
  const enableMessage = () => {
    setResponse(true);
  };

  async function handleChangeLocation(selectedLocation) {
    let count = 0;
    let duplicateValueIndex = [];
    let facilities = selectedLocation;
    if (facilities.length) {
      let latestAddedFacility = facilities[facilities.length - 1].id;
      facilities.map((facility, i) => {
        if (facility.id === latestAddedFacility) {
          duplicateValueIndex.push(i);
          count++;
        }
        return true;
      });
      if (count > 1) {
        for (var i = duplicateValueIndex.length - 1; i >= 0; i--)
          facilities.splice(duplicateValueIndex[i], 1);
      }
    }
    setSelectedLocation(facilities);
  }
  const handleInputChange = (value) => {
    setFacilities(value);
  };
  const clearfacility = () => {
    selectfacilityRef.current.clearValue();
    setSelectedLocation("");
  };

  const cancel = (opt) => {
    initialValueReset();
    setCountryCode("+1");
    setTimeout(() => {
      formik.resetForm();
      setUiLoading(false);
    }, 0);
    disableMessage();
    setLocationError("");
    setMessage("");
    setResetMsg(null);
    props.onHide(opt);
  };

  const initialValueReset = () => {
    initialValues.fname = "";
    initialValues.lname = "";
    initialValues.email = "";
    initialValues.phone = "";
    initialValues.location = "";
    initialValues.cDate = "";
  };

  useEffect(() => {
    checkAddOrEdit();
  }, [props.is_edit]);

  const checkAddOrEdit = () => {
    if (props.is_edit === "true" && props.edit_id) {
      setUiLoading(true);
      setCountryCode("");
      getUserDetailsById(props.edit_id)
        .then((res) => {
          setUiLoading(false);
          if (res.data.status) {
            let data = res.data.data[0];
            setUsers(data);
            initialValues.fname = data.first_name;
            initialValues.lname = data.last_name;
            initialValues.email = data.email;
            initialValues.phone = data.phone_number;
            initialValues.cDate = data.created_date;

            let options = data.assigned_facilities;
            if (options !== undefined && options[0].id) {
              setSelectedLocation(options);
            }
            if (data.country_code !== "" && data.country_code !== null) {
              setCountryCode(data.country_code);
            } else {
              setCountryCode("+1");
            }
          } else {
            enableMessage();
            setMessage(res.data.message);
          }
        })
        .catch((error) => {
          disableLoading();
          enableMessage();
          if (error.response) {
            if (error.response.status !== 404 && error) {
              setMessage(error.response.data.message);
            } else {
              props.history.push("error/error-v1");
            }
          } else {
            setMessage(error.message);
          }
        });
    } else {
      setUiLoading(false);
    }
  };

  const onlyCharacter = (e1) => {
    e1.target.value = e1.target.value.replace(/[^A-Za-z\s]/g, "");
  };

  function handleChangeCountryCode(event) {
    let value = event.target.value;
    setCountryCode(value);
  }

  const formik = useFormik({
    initialValues,
    validationSchema: FacilitySchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setIsLocationError(false);
      let _facilities = [];
      selectedLocation.map((facility) => _facilities.push(facility.id));
      disableMessage();
      if (props.is_edit === "true") {
        enableLoading();
        let user_id = users.user_id;
        editUser(values, countryCode, _facilities, user_id)
          .then((res) => {
            setSubmitting(false);
            disableLoading();
            if (res.data.status) {
              formik.resetForm();
              setSelectedLocation([]);
              cancel("add");
              initialValueReset();
              setUiLoading(true);
            } else {
              enableMessage();
              setMessage(res.data.message);
            }
          })
          .catch((error) => {
            disableLoading();
            setSubmitting(false);
            enableMessage();
            if (error.response) {
              if (error.response.status !== 404 && error) {
                setMessage(error.response.data.message);
              } else {
                props.history.push("error/error-v1");
              }
            } else {
              setMessage(error.message);
            }
          });
      } else {
        if (selectedLocation.length !== 0) {
          enableLoading();
          setIsLocationError(false);
          addUser(values, countryCode, _facilities)
            .then((res) => {
              setSubmitting(false);
              disableLoading();
              if (res.data.status) {
                setSelectedLocation([]);
                cancel("add");
                initialValueReset();
              } else {
                enableMessage();
                setMessage(res.data.message);
              }
            })
            .catch((error) => {
              disableLoading();
              setSubmitting(false);
              enableMessage();
              if (error.response) {
                if (error.response.status !== 404 && error) {
                  setMessage(error.response.data.message);
                } else {
                  props.history.push("error/error-v1");
                }
              } else {
                setMessage(error.message);
              }
            });
        } else {
          setIsLocationError(true);
        }
      }
    },
  });

  const onResetUser = () => {
    setResetLoading(true);
    resetUser(users.user_id)
      .then((res) => {
        setResetLoading(false);
        const { message } = res.data;

        setResetMsg(message);
      })
      .catch((error) => {
        setResetLoading(false);
        if (error.response) {
          if (error.response.status !== 404 && error) {
            setResetMsg(error.response.data.message);
          } else {
            props.history.push("error/error-v1");
          }
        } else {
          setResetMsg(error.message);
        }
      });
  };
  const onlyNumbers = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");
  };

  const checkLocationValidation = () => {
    if (props.is_edit === "false") {
      if (selectedLocation.length === 0) {
        setIsLocationError(true);
      } else {
        setIsLocationError(false);
      }
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const loadFacilityDebounced = useCallback(
    debounce((facilities, callback) => {
      getAllFacilityNames(facilities)
        .then((res) => callback(res.data.data))
        .catch((error) => {});
    }, 500),
    []
  );

  return (
    <div>
      <Dialog
        // {...props}                       //uncomment if required
        PaperProps={{}}
        className={classes.MuiBackdrop + " popupstyle"}
        disableBackdropClick
        TransitionComponent={Transition}
        keepMounted
        fullWidth={true}
        maxWidth="sm"
        open={props.show}
        onClose={cancel}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <div className="dialogTitle">
          <DialogTitle id="scroll-dialog-title" style={{ overflowY: "hidden" }}>
            <div className="header-btn">
              {props.is_edit === "true" ? (
                <>
                  <h2 className="dialogtitle">Edit User</h2>

                  {users !== null ? (
                    <>
                      <button
                        className="btn"
                        style={{
                          border: "1px solid black",
                          marginLeft: "25px",
                          cursor:
                            users.userStatus === "LOCKED_OUT" ||
                            users.userStatus === "PASSWORD_EXPIRED"
                              ? "pointer"
                              : "auto",
                        }}
                        // disabled={users.userStatus !== "LOCKED_OUT"}
                        onClick={() => {
                          onResetUser();
                        }}
                      >
                        Reset
                        {resetLoading && (
                          <i
                            className="ml-3 spinner spinner-dark"
                            style={{ marginRight: "10px" }}
                          ></i>
                        )}
                      </button>
                      {resetMsg !== null ? (
                        <p
                          className="d-inline-flex reset-user-msg"
                          style={{ marginLeft: "10%" }}
                        >
                          {resetMsg}
                        </p>
                      ) : null}
                    </>
                  ) : null}
                </>
              ) : (
                <h2 className="dialogtitle">Add User</h2>
              )}
            </div>
          </DialogTitle>
          <IconButton onClick={cancel} aria-label="close" className="closebtn">
            <CloseIcon />
            close
          </IconButton>
        </div>

        <DialogContent>
          <DialogContentText
            component="div"
            id="scroll-dialog-description"
            tabIndex={-1}
          >
            {!uiLoading ? (
              <form onSubmit={formik.handleSubmit} id="myUserForm">
                <div className="row">
                  <div className="col">
                    <TextField
                      id="fname"
                      className={classes.root}
                      name="fname"
                      margin="normal"
                      placeholder="First"
                      label="First Name"
                      type="text"
                      inputProps={{ maxLength: 50 }}
                      fullWidth
                      onInput={(e1) => onlyCharacter(e1)}
                      variant="outlined"
                      color="secondary"
                      size="small"
                      required
                      {...formik.getFieldProps("fname")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("fname", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {" "}
                              <HighlightOffRoundedIcon />{" "}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    {formik.touched.fname && formik.errors.fname ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.fname}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <TextField
                      id="lname"
                      className={classes.root}
                      name="lname"
                      margin="normal"
                      placeholder="Last Name"
                      label="Last Name"
                      type="text"
                      inputProps={{ maxLength: 50 }}
                      required
                      fullWidth
                      onInput={(e1) => onlyCharacter(e1)}
                      variant="outlined"
                      color="secondary"
                      size="small"
                      {...formik.getFieldProps("lname")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("lname", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {" "}
                              <HighlightOffRoundedIcon />{" "}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    {formik.touched.lname && formik.errors.lname ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.lname}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <TextField
                      id="email"
                      className={classes.root}
                      name="email"
                      margin="normal"
                      placeholder="Email"
                      label="Email"
                      inputProps={{ maxLength: 50 }}
                      fullWidth
                      disabled={props.is_edit === "true" ? true : false}
                      variant="outlined"
                      color="secondary"
                      size="small"
                      required
                      {...formik.getFieldProps("email")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("email", "");
                              }}
                            >
                              <HighlightOffRoundedIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    {formik.touched.email && formik.errors.email ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.email}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-3 countrycode-select">
                    <FormControl
                      variant="outlined"
                      fullWidth
                      size="small"
                      className={classes.root}
                    >
                      <Select
                        fullWidth
                        color="secondary"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        className={classes.root}
                        onChange={handleChangeCountryCode}
                        value={countryCode}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                        SelectProps={{
                          native: true,
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        required
                      >
                        {CountryCode.map((value, index) => {
                          return (
                            <MenuItem key={index} value={value.dial_code}>
                              {value.code}&nbsp;{value.dial_code}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="col-sm-9">
                    <TextField
                      id="phone"
                      className={classes.root}
                      name="phone"
                      margin="normal"
                      placeholder="Phone Number"
                      label="Phone Number"
                      fullWidth
                      onInput={(e) => onlyNumbers(e)}
                      inputProps={{ maxLength: 10 }}
                      variant="outlined"
                      color="secondary"
                      size="small"
                      required
                      {...formik.getFieldProps("phone")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                formik.setFieldValue("phone", "");
                              }}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {" "}
                              <HighlightOffRoundedIcon />{" "}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    {formik.touched.phone && formik.errors.phone ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.phone}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="row" style={{ paddingTop: "15px" }}>
                  <div className="col">
                    <FormControl
                      variant="outlined"
                      fullWidth
                      size="small"
                      className={classes.root}
                    >
                      <AsyncSelect
                        id="select-facility"
                        name="facility"
                        isMulti
                        ref={selectfacilityRef}
                        classNamePrefix="async-select"
                        value={selectedLocation}
                        placeholder="select Facility"
                        getOptionLabel={(e) => e.name}
                        getOptionValue={(e) => e.id}
                        loadOptions={loadFacilityDebounced}
                        onChange={handleChangeLocation}
                        onInputChange={handleInputChange}
                        onSelectResetsInput={true}
                        onBlurResetsInput={true}
                        isClearable={clearfacility}
                        onClick={checkLocationValidation}
                        noOptionsMessage={() => "No Records Found"}
                      />
                    </FormControl>

                    {isLocationError ? (
                      <div className="fv-plugins-message-container locationError">
                        <div className="fv-help-block">{locationError}</div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="col-xs-12" align="left">
                  {responseStatus ? (
                    <div
                      style={{ marginTop: "10px" }}
                      className={`${classes.alertMsg}`}
                    >
                      {errorMsg}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <DialogActions style={{ paddingRight: "0" }}>
                  <button className="btn btn shadow-btn " onClick={cancel}>
                    Cancel
                  </button>

                  <button
                    className="saveButton"
                    color="secondary"
                    variant="contained"
                    type="submit"
                    form="myUserForm"
                  >
                    Save
                    {loading && (
                      <span className="ml-3 spinner spinner-light"></span>
                    )}
                  </button>
                </DialogActions>
              </form>
            ) : (
              <div align="center">
                {responseStatus ? (
                  <div
                    style={{ marginBottom: "30px" }}
                    className={`d-flex p-2 ${classes.alertMsg}`}
                  >
                    {errorMsg}
                  </div>
                ) : (
                  <span className="ml-3 spinner spinner-dark"></span>
                )}
              </div>
            )}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
